import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'lib-app-entity-chart-import-toolbar',
  templateUrl: './entity-chart-import-toolbar.component.html',
  styleUrls: ['./entity-chart-import-toolbar.component.scss'],
})
export class EntityChartImportToolbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
